import $ from 'jquery'
import { createApp as createVue, watch } from 'vue'
import { makeSafeForCss } from './shared/common-functions.js'
import socket from './socket.js'

import UserList from '../components/room-userlist.vue'

$( function(){
	// $( 'button' ).button()

	$( 'body' ).on( 'click', '.pops-up', function( ev ){
		ev.preventDefault()
		var $popup = $( this ).next( '.to-pop-up' )
		$popup.show().position({of: $( this ), my: 'center center', at: 'center center', collision: 'fit'})
		$popup.find( '.closer' ).on( 'click submit', function( ev ){
			$popup.hide()
		})
	})

	window.onbeforeunload = function( e ){
		e = e || window.event
		var msg = 'Confirm closing the chat(In case you hit refresh, back, ctrl+f4, etc on accident).'
		// For IE and Firefox
		if( e ){
			e.returnValue = msg
		}
		// For Safari
		return msg
	}

	global.chatUi = {}

	const $updates = new rph.CustomDialog( 'Updates',
			'<iframe src="//chat.rphaven.com/updates.html?' + rph.version + '" style="border:0;width:100%;height:100%" />',
			{draggable: false, closeOnEscape: false, resizable: false, modal: true, height: 500, width: 790}),

		roomManager = new rph.CustomDialog( 'Room Management',
			`<iframe class="group-iframe" src="" style="width:100%; height:50%; border:0" />
						<div style="height:50%">
							<div class="users"><h2>Management</h2><div class="management" /></div>
							<div class="users"><h2>Members</h2><div class="members" /></div>
							<div class="users"><h2>Banned</h2><div class="bans" /></div>
							<!--<div class="users"><h2>Group Members</h2><div class="inGroup" /></div>-->
							<div class="ui-state-highlight mods-only ui-corner-all" style="margin:2px 4px;clear:left;">
								<label style="width:100%;">Topic<input type="text" class="topic" style="max-width:100%;" /></label>
							</div>
							<div class="owners-only ui-state-highlight ui-corner-all" style="margin:2px 4px">
								<label style="width:100%;" title="Must be a group that the room owner is in, and must not already be linked to another room">Link to Group<select class="group" style="width:100%;" /></label>
								<label>Password<input type="text" class="pw" /></label>
								<label class="group-only" title="How many alternate characters under a single account may join">Max Alts per Account<input type="text" class="maxPerAcc" /></label>
								<label title="The most characters that may join the room before it\'s full(0/empty = unlimited)">Max Characters<input type="text" class="maxUser" /></label>
							</div>
							<div class="ui-state-highlight ui-corner-all" style="margin:2px 4px">
								<!--<label class="owners-only">Hide Room<input type="checkbox" /></label>-->
								<label  class="mods-only group-only" title="Announce in the room when someone in it posts a LFRP ad">Show LFRP Ads<input type="checkbox" class="showLfrp" /></label>
								<label class="owners-only group-only" title="Only group members can join the room">Group Members Only<input type="checkbox" class="groupOnly" /></label>
							</div>
							<button>Submit Room Settings</button>
						</div>`,
			{height: 600, width: '75%'})
	roomManager.$el.find( 'label.owners-only, .owners-only label' ).prepend( '<span title="Settable only by an owner" class="icon owner" />' )
	roomManager.$el.find( 'label.mods-only, .mods-only label' ).prepend( '<span title="Settable only by an owner or moderator" class="icon mod" />' )
	roomManager.$el.find( 'label.group-only, .group-only label' ).prepend( '<span title="Room must be linked to a group" class="icon is-group" />' )
	roomManager.$el.on( 'click', 'input, select, label', function( ev ){
		if( $( this ).css( 'opacity' ) !== '1' ){
			ev.stopPropagation()
			ev.preventDefault()
			$( this ).blur()
			$( this ).find( 'input' ).blur()
		}
	})
	roomManager.setRoom = function( Room ){
		this.Room = Room
		this.$el.attr( 'data-roomname', makeSafeForCss( Room.props.name ) )
	}
	roomManager.send = function(){
		var Room = this.Room,
			changedProps = {}
		const userid = [...Room.props.owners, ...Room.props.mods].filter( ( staffid ) => account.userids.includes( staffid ) )[0]
		if( typeof userid === 'undefined' ){
			return
		}
		roomManager.$el.find( 'input, select' ).each( function( ev ){
			var $this = $( this ),
				val = $this.val()
			if( $this.is( '[type=checkbox]' ) ){
				if( $this.is( ':checked' ) ){
					val = true
				} else {
					val = false
				}
			}
			val = parseInt( val ) == val ? parseInt( val ) : val
			val = val === 'false' || 0 || '' ? false : val
			val = val === 'true' ? true : val
			changedProps[$this.attr( 'class' )] = val
			if( changedProps[$this.attr( 'class' )] === Room.props[$this.attr( 'class' )] ){
				delete changedProps[$this.attr( 'class' )]
			}
		})
		socket.emit( 'modify-room', {room: this.Room.props.name, userid: userid, props: changedProps})
	}
	roomManager.$el.find( 'button' ).button().bind( 'click', function(){
		roomManager.send()
	})

	function PasswordInputter(){
		var thisObj = this
		this.$el = $( '<div id="password-inputter" class="ui-corner-all"><div class="inner" style="padding:5px;"><p>Password required. Input one:</p><input class="password" /><button style="background:rgba(200,50,25,0.6);">CANCEL</button></div></div>' )
			.hide().prependTo( 'body' )
		this.$el.find( 'button' ).button().bind( 'click', function(){
			thisObj.$el.hide()
		})

		this.callback = function(){}

		this.attachTo = function( $target, callback ){
			this.$el.show()
			this.callback = callback

			this.$el.position({my: 'center bottom', at: 'center top', of: $target, collision: 'flip flip'})
		}
		$( '<button>INPUT PASSWORD</button>' ).button().on( 'click', function(){
			thisObj.callback( thisObj.$el.find( 'input' ).val() )
			thisObj.$el.hide()
		}).insertAfter( this.$el.find( '.password' ) )
		this.$el.find( 'input' ).keydown( function( ev ){
			if( ev.keyCode === 13 ){
				thisObj.callback( thisObj.$el.find( 'input' ).val() )
				thisObj.$el.hide()
			}
		})
		return this
	}
	rph.PasswordInputter = new PasswordInputter()

	function RoomList(){
		var thisObj = this
		this.$joinerEl = $( '<div id="room-joiner" style="height:100%;padding:0 15%;overflow-y:auto;" />' ).hide()
			.prependTo( '#chat-top' )
		this.$joinerEl.append( '<div class="top" />\n\
			<div class="bottom flex-parent" />' )
		this.$joinerEl.find( '.top' ).append( '<ul class="list-item" id="rooms-header"><li class="count">#</li><li class="name">Room Name</li><li class="topic">Topic</li></ul>' )

		this.$joinerEl.find( '.bottom' ).append( '<div style="padding:1px 0 0 6px;text-align:left; flex-grow: 1;" class="ui-button ui-corner-all flex-parent"><input class="room-name" /> <span>A room will be created if it doesn\'t exist</span></div>' )

		$( '<button class="cancel">Load empty permanent rooms</button>' )
			.button().bind( 'click', function(){
				socket.emit( 'get-empty-rooms' )
				$( this ).remove()
			}).appendTo( this.$joinerEl.find( '.top' ) )

		$( '<button style="background:rgba(200,50,25,0.6);" class="cancel">CANCEL</button>' )
			.button().bind( 'click', function(){
				thisObj.hide()
			}).appendTo( this.$joinerEl.find( '.bottom' ) )
		$( '<button class="join">JOIN</button>' ).button().bind( 'click', function(){
			// make list of users, then callback with selection
			var $this = $( this )
			rph.UserSelector.attachTo( $this, function( User ){
				var roomname = thisObj.$joinerEl.find( '.bottom input' ).val(),
					Room = getRoom( roomname )
				if( Room && Room.props.pw === true ){
					rph.PointerInput.attachTo( $this ).prop( 'placeholder', 'Input required password' ).onSubmit( function(){
						socket.emit( 'join', {name: roomname, userid: User.props.id, pw: this.val()})
					})
				} else {
					socket.emit( 'join', {name: roomname, userid: User.props.id})
				}
			})
			//
		}).appendTo( this.$joinerEl.find( '.bottom' ) )
		this.$joinerEl.find( '.bottom input' ).keyup( function( ev ){
			if( ev.keyCode === 13 ){
				thisObj.$joinerEl.find( '.bottom button.join' ).click()
			}
		})

		this.$el = $( '<div class="rooms nano-content" />' ).appendTo( '#userlist .inner' )
		$( '#userlist .inner' )

		this.$joinerEl.find( '.top' ).on( 'click', '.list-item', function( ev ){
			var $this = $( this ),
				Room = $this.data( 'room' )
			thisObj.$joinerEl.find( '.bottom input' ).val( Room.props.name )
			rph.UserSelector.attachTo( $this, function( User ){
				if( Room && Room.props.pw === true ){
					rph.PointerInput.attachTo( $this ).prop( 'placeholder', 'Input required password' ).onSubmit( function(){
						socket.emit( 'join', {name: Room.props.name, userid: User.props.id, pw: this.val()})
					})
				} else {
					socket.emit( 'join', {name: Room.props.name, userid: User.props.id})
				}
			})
		})

		this.$el.on( 'click', '.manage', function( ev ){
			var roomname = $( this ).closest( '.room' ).data( 'roomname' ),
				Room = getRoom( roomname )

			roomManager.setRoom( Room )
			roomManager.show()
				.$el.attr( 'class', 'room-header-' + makeSafeForCss( roomname ) )
				.addClass( 'room' )
				.data( 'roomname', Room.props.name )
			roomManager.$el.find( '.owners-only label, label.owners-only' ).css( 'opacity', '0.3' )
			roomManager.$el.find( '.mods-only label, label.mods-only' ).css( 'opacity', '0.3' )
			var isOwner = isOwnerOf( Room ),
				isMod = isModOf( Room )
			if( isOwner ){
				roomManager.$el.find( '.owners-only label, label.owners-only' ).css( 'opacity', '1' )
				roomManager.$el.find( '.mods-only label, label.mods-only' ).css( 'opacity', '1' )
			}
			if( isMod ){
				roomManager.$el.find( '.mods-only label, label.mods-only' ).css( 'opacity', '1' )
			}
			roomManager.$el.find( '.group-only' ).css( 'opacity', '0.3' )
			if( Room.props.group ){
				roomManager.$el.find( '.group-only' ).css( 'opacity', '1' )
			}
			if( isOwner || isMod ){
				$( this ).text( 'Manage' )
			} else {
				$( this ).text( 'Info' )
			}

			roomManager.$el.find( '.group' ).find( 'option' ).remove()
			roomManager.$el.find( '.group' ).append( '<option val="0">None</option>' )
			var groups = []
			account.userids.forEach( ( userid ) => {
				getUserById( userid, function( User ){
					if( isOwnerOf( Room, User ) ){
						User.props.groups.forEach( ( group ) => {
							if( !roomManager.$el.find( '.group[val=' + group.id + ']' )[0] && group.rights >= 8 ){
								roomManager.$el.find( '.group' ).append( '<option val="' + group.id + '">' + group.name + '</option>' )
							}
						})
					}
				})
			})

			for( const [key, value] of Object.entries( Room.props ) ){
				roomManager.$el.find( '.' + key ).val( value )
				if( roomManager.$el.find( '.' + key ).is( '[type=checkbox]' ) ){
					roomManager.$el.find( '.' + key ).prop( 'checked', value )
				}
			}

			roomManager.$el.find( '.users .management' ).empty()
			roomManager.$el.find( '.users .members' ).empty()
			roomManager.$el.find( '.users .bans' ).empty()
			Room.props.owners.forEach( ( userid ) => {
				getUserById( userid, function( User ){
					var $el = User.$createEl()
					$( `<a class="name" title"${User.props.name}" data-name="${User.props.name}">${User.props.name}</a>` )
						.appendTo( roomManager.$el.find( '.users .management' ) )
				})
			})
			Room.props.mods.forEach( ( userid ) => {
				getUserById( userid, function( User ){
					$( `<a class="name" title"${User.props.name}" data-name="${User.props.name}">${User.props.name}</a>` )
						.appendTo( roomManager.$el.find( '.users .management' ) )
				})
			})
			Room.props.members.forEach( ( userid ) => {
				$( '<div>' + userid + '</div>' )
					.appendTo( roomManager.$el.find( '.users .members' ) )
			})
			Room.props.bans.forEach( ( userid ) => {
				getUserById( userid, function( User ){
					$( `<a class="name" title"${User.props.name}" data-name="${User.props.name}">${User.props.name}</a>` )
						.appendTo( roomManager.$el.find( '.users .bans' ) )
				})
			})

			if( typeof Room.props.group !== 'undefined' ){
				if( Room.props.group ){
					roomManager.$el.find( '.group-iframe' ).show().attr( 'src', '//www.rphaven.com/secure/group_iframe.php?id=' + Number( Room.props.groupid ) )
				} else {
					roomManager.$el.find( '.group-iframe' ).hide()
				}
			}
		})

		this.$el.on( 'click', '.join', function( ev ){
			var $this = $( this )
			rph.UserSelector.attachTo( $this, function( User ){
				var roomname = $this.closest( '.room' ).data( 'roomname' ),
					Room = getRoom( roomname )
				if( Room && Room.props.pw === true ){
					rph.PointerInput.attachTo( $this ).prop( 'placeholder', 'Input required password' ).onSubmit( function(){
						console.log( 'join', roomname, this.val() )
						socket.emit( 'join', {name: roomname, userid: User.props.id, pw: this.val()})
					})
				} else {
					socket.emit( 'join', {name: roomname, userid: User.props.id})
				}
			})
		})

		this.$el.on( 'click', '.header', function( ev ){
			var $roomEl = $( this ).closest( '.room' ),
				roomname = $roomEl.data( 'roomname' )
			if( $( ev.target ).is( $roomEl.find( '.manage' ) ) ){
				return false
			}
			if( !$roomEl.find( '.content' ).is( ':visible' ) ){
				thisObj.showRoom( roomname )
			} else {
				thisObj.hideRoom( roomname )
			}
		})

		this.addRoom = function( props ){
			const Room = getRoom( props.name ),
				$joinEl = $( '<ul class="list-item room room-header-' + makeSafeForCss( props.name ) + '"><li class="count">' + props.count + '</li><li class="name"><span class="icon pw" title="Passworded" />' + props.name + '</li><li class="topic">' + props.topic + '</li></ul>' )
					.data( 'room', Room )
			let displayStyle = 'display: none;'
			if( props.count === 0 ){ // do the right positioning at the start as moving it around in update is most costly
				$joinEl.css( 'opacity', '0.5' )
				$joinEl.appendTo( this.$joinerEl.find( '.top' ) )
			} else {
				$joinEl.insertAfter( this.$joinerEl.find( '#rooms-header' ) )
				displayStyle = ''
			}

			const $el = $( `<div class="room room-header-${makeSafeForCss( props.name )}" style="${displayStyle}">
					<div class="header">
						<span class="count">${props.count}</span>-<span class="name"><span class="icon pw" title="Passworded" />${props.name}</span>
					</div>
					<div class="content" style="display:none">
						<div class="panel" />
						<user-list :list="users" :room="room" class="users" />
					</div>
				</div>` ).data( 'roomname', props.name ).appendTo( this.$el )

			$( '<button class="manage">Info</button>' ).button().appendTo( $el.find( '.header' ) )

			$( '<button class="join">Enter Room</button>' ).button().appendTo( $el.find( '.panel' ) )

			const userlistVue = createVue({
				data: () => ({
					users: Room.users,
					room: Room
				}),
				components: {
					UserList
				}
			})
				.mount( $el[0] )

			// $('<a class="join-group" target="_blank">Join Group</a>').button().hide()
			//		.appendTo( $el.find('.panel') );

			if( props.pw === true ){
				$joinEl.addClass( 'pw' )
				$el.addClass( 'pw' )
			}

			this.updateProps( Room.props.name, Room.props, true )
			$( '#userlist .inner' )

			return this
		}
		this.removeRoom = function( roomname ){
			this.$el.find( '.room-header-' + makeSafeForCss( roomname ) ).remove()
			this.$joinerEl.find( '.room-header-' + makeSafeForCss( roomname ) ).remove()
			return this
		}
		this.show = function(){
			$( '#top' ).text( 'Select a room to join, or create a new room' )
			this.$joinerEl.show()
			return this
		}
		this.hide = function(){
			this.$joinerEl.hide()
			return this
		}
		this.showRoom = function( roomname ){
			var $el = this.$el.find( '.room-header-' + makeSafeForCss( roomname ) + '' )
			if( !$el.find( '.content' ).is( ':visible' ) ){
				$el.find( '.content' ).show()
				socket.emit( 'listen', roomname )
			}
			return this
		}
		this.hideRoom = function( roomname ){
			var $el = this.$el.find( '.room-header-' + makeSafeForCss( roomname ) + '' )
			if( $el.find( '.content' ).is( ':visible' ) ){
				$el.find( '.content' ).hide()
				socket.emit( 'unlisten', roomname )
			}
			return this
		}
		this.updateProps = function( roomname, props, initialUpdate ){
			var thisObj = this,
				Room = getRoom( roomname ),
				$joinerEl = thisObj.$joinerEl.find( '.room-header-' + makeSafeForCss( roomname ) ),
				$listEl = thisObj.$el.find( '.room-header-' + makeSafeForCss( roomname ) ),
				$managerEl = roomManager.$el.filter( '.room-header-' + makeSafeForCss( roomname ) )
			if( typeof props.count !== 'undefined' ){
				if( props.count === 0 ){
					$joinerEl.appendTo( this.$joinerEl.find( '.top' ) ).css( 'opacity', '0.5' )
					$listEl.hide().appendTo( this.$el )
				} else if( props.count === 1 ){
					$listEl.prependTo( this.$el )
					$joinerEl.insertAfter( this.$joinerEl.find( '#rooms-header' ) ).css( 'opacity', '1' )
				}
				if( props.count > 0 ){
					$listEl.show()
				}
				$listEl.find( '.count' ).text( props.count )
			}
			for( const [key, value] of Object.entries( props ) ){
				if( key !== 'name' ){
					$listEl.find( '.' + key ).text( value )
					$joinerEl.find( '.' + key ).text( value )
				}
			}
			if( props.groupid && roomManager.$el.attr( 'data-roomname' ) == makeSafeForCss( roomname ) ){
				if( props.groupid ){
					roomManager.$el.find( '.group-iframe' ).show().attr( 'src', '//www.rphaven.com/secure/group_iframe.php?id=' + Number( props.groupid ) ) // why is 1 changing to true?
				} else {
					roomManager.$el.find( '.group-iframe' ).hide()
				}
			}
			if( props.owners || props.mods || props.bans || props.members ){
				if( isOwnerOf( Room ) || isModOf( Room ) ){
					$listEl.find( '.manage' ).text( 'Manage' )
				} else {
					$listEl.find( '.manage' ).text( 'Info' )
				}

				if( $managerEl.is( ':visible' ) ){
					$managerEl.find( '.users .management' ).empty()
					$managerEl.find( '.users .members' ).empty()
					$managerEl.find( '.users .bans' ).empty()
					Room.props.owners.forEach( ( userid ) => {
						getUserById( userid, function( User ){
							$( `<a class="name" title="${User.props.name}" data-name="${User.props.name}">${User.props.name}</a>` )
								.appendTo( $managerEl.find( '.users .management' ) )
						})
					})
					Room.props.mods.forEach( ( userid ) => {
						getUserById( userid, function( User ){
							$( `<a class="name" title="${User.props.name}" data-name="${User.props.name}">${User.props.name}</a>` )
								.appendTo( $managerEl.find( '.users .management' ) )
						})
					})
					Room.props.members.forEach( ( userid ) => {
						$( '<div>' + userid + '</div>' )
							.appendTo( roomManager.$el.find( '.users .members' ) )
					})
					Room.props.bans.forEach( ( userid ) => {
						getUserById( userid, function( User ){
							$( `<a class="name" title="${User.props.name}" data-name="${User.props.name}">${User.props.name}</a>` )
								.appendTo( $managerEl.find( '.users .bans' ) )
						})
					})
				}
			}
			if( typeof props.group !== 'undefined' ){
				if( props.group ){
					$listEl.find( '.join-group' ).show()
				} else {
					$listEl.find( '.join-group' ).hide()
				}
			}
			if( initialUpdate !== true ){
				const pickedSettings = Object.fromEntries( Object.entries( props ).filter( ( [key] ) => ['topic', 'pw', 'group', 'maxUser', 'maxPerAcc', 'hidden', 'showLfrp', 'groupOnly'].includes( key ) ) )
				if( Object.keys( pickedSettings ).length ){
					if( typeof pickedSettings.pw !== 'undefined' ){
						if( pickedSettings.pw === true ){
							$listEl.addClass( 'pw' )
							$joinerEl.addClass( 'pw' )
						} else {
							$listEl.removeClass( 'pw' )
							$joinerEl.removeClass( 'pw' )
						}
					}
					if( typeof pickedSettings.topic !== 'undefined' && Room.active ){
						$( '#top' ).html( '<span>' + Room.props.name + ' | ' + parseMsg( Room.props.topic ) + '</span>' ).attr( 'title', Room.props.topic )
					}
					if( Room.$el.closest( 'body' )[0] ){
						var len = Object.keys( pickedSettings ).length
						const $el = Room.appendMessage(
							'<span class="first">&nbsp;</span><p>An Owner or Moderator has changed the rooms settings:</p>'
						).addClass( 'sys' )

						let i = 0
						for( const [key, value] of Object.entries( pickedSettings ) ){
							if( i < len - 1 ){
								$el.append( '<span>' + key + ': ' + value + ', </span>' )
							} else {
								$el.append( '<span>' + key + ': ' + value + '</span>' )
							}
							i += 1
						}
					}
				}
			}
			return this
		}

		return this
	}
	chatUi.RoomList = new RoomList()

	$( '.createRoom' ).bind( 'click', function(){
		chatUi.RoomList.show()
	})

	$( '.menu' ).on( 'click', function( ev ){
		var $this = $( this )
		$this.parent().parent().find( '.dropdown' ).toggle()
	}).on( 'mouseup', function( ev ){
		var $this = $( this )
		setTimeout( function(){
			$( 'body' ).one( 'click.dropdown', function( ev ){
				if( $this.parent().parent().find( '.dropdown' ).is( ':visible' ) ){
					$this.parent().parent().find( '.dropdown' ).hide()
				}
			})
		}, 1 )
	})

	$( '.manage-characters' ).on( 'click', function( ev ){
		$( '#settings-dialog' ).show()
			.find( '.tabs a[href="#account-settings"]' ).click()
	})

	new rph.CustomDialog( 'About RPH',
		`<div style="padding:30px 60px;">
							<p style="text-align:center; font-size:300%">Client Version: ${rph.version}</p>
							<p style="text-align:center;"><a href="https://chat.rphaven.com/updates.html?${rph.version}" target="_blank">Update Notes</a> | <a href="https://discord.gg/93SEATv" target="_blank">Discord/Support</a></p>
							<p style="margin-top:40px;">Roleplay Haven (RPH) is a web-based app that I started on over 10 years ago, on January 14th 2008, if I can remember correctly, after taking over for someone who no longer wanted to deal with the hassle it brought them.</p>
							<p>Originally, RPH was a little site running a chat script called "Flashchat", but it has since gone through multiple new chats created and updated by myself, Sadtaco.</p>
							<p>Special thanks to ShinoAsada and the community whose ideas have helped shape features, and to those who have spent money, some especially generously.</p>
							<p>Emojis are attributed to <a href="https://twemoji.twitter.com/">Twitter's open source Twemoji project</a></p>
						</div>`,
		{draggable: false, resizable: false, modal: false, height: 450, width: 600})

	$( '.about' ).on( 'click', ( ev ) => {
		rph.dialogs['About RPH'].show()
	})
})

var kkeys = []
const konami = '38,38,40,40,37,39,37,39,66,65'
$( document ).keydown( function( e ){
	kkeys.push( e.keyCode )
	if( kkeys.toString().indexOf( konami ) >= 0 ){
		// eslint-disable-next-line no-caller
		$( document ).unbind( 'keydown', arguments.callee )
		$.getScript( 'http://www.cornify.com/js/cornify.js', function(){
			cornify_add()
			$( document ).keydown( cornify_add )
		})
	}
	if( kkeys.length > 12 ){
		kkeys.shift()
	}
})
